<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Invoice Due List
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date1"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date1"
            @input="menu1 = false"
            @click:date="dateSelect"
            :max="date2"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date2"
              label="Select End Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date2"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
            :min="date1"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="">
        <v-btn depressed color="primary" v-on:click="initialize"
        ><v-icon>mdi-magnify</v-icon></v-btn
        >
      </v-col>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-btn
        depressed
        color="primary"
        append-icon="mdi-printer"
        v-on:click="printList"
        >Print</v-btn
      >
    </v-card-title>
    <v-card id="print">
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        disable-pagination
        hide-default-footer
        :loading="loadingstatus"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top v-if="item.status == 'due'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="invoice_due_collect(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="green"
                label
                outlined
                small
              >
                <v-icon left> mdi-inbox </v-icon>
              </v-chip>
            </template>
            <span>Due Collect</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      loadingstatus: true,
      menu1: false,
      menu2: false,
      loading: true,
      headers: [
        {
          text: "Invoice ID",
          align: "start",
          value: "invoice_id",
        },
        {
          text: "Date",
          value: "inv_date",
        },
        {
          text: "Invoice Type",
          value: "invoice_type",
        },
        {
          text: "Patient ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Due Amount", value: "due_amount" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoice Due List",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },

  methods: {
    dateSelect() {
      this.initialize();
    },
    initialize() {
      this.loadingstatus = true;
      atshq
        .get("invoices/due-list?date=" + this.date1 + "&enddate=" + this.date2)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loadingstatus = false;
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },


    invoice_due_collect(item) {
      //   console.log(item);
      window.open(
        this.returnUrl + "front_desk/invoiceDueCollect/" + item.invoice_id
      );
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=950, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
        '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );

      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
      );
      docprint.document.write(
        "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px; }"
      );
      docprint.document.write("table th, table th {text-align: center;}");
      docprint.document.write("table {width: 100%; border-spacing: 0px;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(
        '<h2 class="box-title" style="margin:0px; padding: 0px;">Dristi Eye Hospital</h2>'
      );
      docprint.document.write(
        "<p style='text-transform: uppercase;'>Invoice Due List<br/>" +
          "<br/>Date: " +
          this.date1 +" to "+this.date2+
          "</p>"
      );
      docprint.document.write(
        '<div style="width: 100%;float: left;border-top: 5px solid silver;padding-bottom: 5px;"></div>'
      );
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>